import { SModal } from './ModalCentered.styles';
import { ModalProps } from './ModalCentered.types';

export const ModalCentered = ({ ...props }: ModalProps) => {
  return <SModal {...props} />;
};
